import { render } from "./ProvinceTaskImageModal.vue?vue&type=template&id=5f22c52b&scoped=true&ts=true"
import script from "./ProvinceTaskImageModal.ts?vue&type=script&lang=ts"
export * from "./ProvinceTaskImageModal.ts?vue&type=script&lang=ts"

import "./ProvinceTaskImageModal.scss?vue&type=style&index=0&id=5f22c52b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f22c52b"]])

export default __exports__